import { TIMEZONE } from "@/constants/time"
import dayjs from "dayjs"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

export const ENV = {
  VITE_REGISTER_START_TIME: import.meta.env.VITE_REGISTER_START_TIME,
  VITE_REGISTER_END_TIME: import.meta.env.VITE_REGISTER_END_TIME,
  VITE_EVENT_START_TIME: import.meta.env.VITE_EVENT_START_TIME,
  VITE_COUNT_DOWN_START_TIME: import.meta.env.VITE_COUNT_DOWN_START_TIME,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT
}

export const REGISTER_START_TIME = dayjs(ENV.VITE_REGISTER_START_TIME).tz(
  TIMEZONE.KST
)
export const REGISTER_END_TIME = dayjs(ENV.VITE_REGISTER_END_TIME).tz(
  TIMEZONE.KST
)
export const EVENT_START_TIME = dayjs(ENV.VITE_EVENT_START_TIME).tz(
  TIMEZONE.KST
)
export const COUNT_DOWN_START_TIME = dayjs(ENV.VITE_COUNT_DOWN_START_TIME).tz(
  TIMEZONE.KST
)

export const IS_UPCOMING_EVENT = dayjs().isAfter(REGISTER_END_TIME)

export const SHOW_COUNTDOWN = dayjs().isSameOrAfter(COUNT_DOWN_START_TIME)

export const IS_BEFORE_REGISTER_TIME = dayjs().isBefore(REGISTER_START_TIME)

export const IS_REGISTER_PERIOD =
  dayjs().isSameOrAfter(REGISTER_START_TIME) &&
  dayjs().isSameOrBefore(REGISTER_END_TIME)

export const IS_AFTER_REGISTER_TIME = dayjs().isAfter(REGISTER_END_TIME)

export const IS_BEFORE_EVENT_TIME = dayjs().isBefore(EVENT_START_TIME)
